import { ReadonlyRadioWithIconSelection } from '@exam-center/components';
import { Grid, Text, Flex, ReadonlyField } from '@shared/components';
export interface BasicInformationReadonlyFieldProps {
  examEventName: string;
  examType: {
    icon: JSX.Element;
    label: string;
    checked: boolean;
  }[];
  registrationType: {
    icon: JSX.Element;
    label: string;
    checked: boolean;
  }[];
  examineeImportMethod?: {
    icon: JSX.Element;
    label: string;
    checked: boolean;
  }[];
}

export default function BasicInformationReadonlyField(
  props: Readonly<BasicInformationReadonlyFieldProps>,
) {
  const { examEventName, examType, registrationType, examineeImportMethod = [] } = props;
  return (
    <Grid
      sx={{
        gridTemplateColumns: '240px 1fr',
        gap: (theme) => theme.spacing(6),
      }}
    >
      <Text variant='body1Semibold'>ข้อมูลทั่วไป</Text>
      <Flex sx={{ gap: (theme) => theme.spacing(4), flexGrow: 1, flexDirection: 'column' }}>
        <ReadonlyField label='ชื่อรอบสอบ' content={examEventName} />
        <ReadonlyRadioWithIconSelection label='Exam Type' row options={examType} />
        <ReadonlyRadioWithIconSelection label='Registration Type' row options={registrationType} />
        <ReadonlyRadioWithIconSelection
          label='Examinee Import Method'
          row
          options={examineeImportMethod}
        />
      </Flex>
    </Grid>
  );
}
